import React from 'react';
import { Alert, Button, Container } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // In a production app, you might want to log this to a service like Sentry
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    // Force a reload of the parent component
    if (this.props.onReset) {
      this.props.onReset();
    }
  }

  handleNavigateHome = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = '/';
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container className="py-5">
          <Alert variant="danger">
            <Alert.Heading>Something went wrong</Alert.Heading>
            <p>
              The application has encountered an unexpected error. Please try refreshing the page or navigate back to the homepage.
            </p>
            {this.state.error && (
              <p className="mb-0">
                <strong>Error:</strong> {this.state.error.toString()}
              </p>
            )}
            <hr />
            <div className="d-flex flex-column">
              <details className="mb-3">
                <summary style={{ cursor: 'pointer' }}>Error Details</summary>
                <pre className="mt-2 p-3 bg-light rounded" style={{ whiteSpace: 'pre-wrap', fontSize: '0.875rem' }}>
                  {this.state.error?.toString()}
                  {this.state.errorInfo?.componentStack}
                </pre>
              </details>
              <div className="d-flex gap-3">
                <Button variant="outline-primary" onClick={this.handleReset}>
                  Try Again
                </Button>
                <Button variant="primary" onClick={this.handleNavigateHome}>
                  Go to Homepage
                </Button>
              </div>
            </div>
          </Alert>
        </Container>
      );
    }

    // Return children if there's no error
    return this.props.children;
  }
}

export default ErrorBoundary;